import { useEffect, useState } from 'react'
import tonLeadService from '@/services/tonLead'
import { Lead } from '@/services/tonLead/types'

const sessionStorageKey = 'ton-lead'

export function useTonLead() {
  const [lead, setLead] = useState('')
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (!sessionStorage) return

    const sessionLead = sessionStorage.getItem(sessionStorageKey)

    if (sessionLead) {
      setLead(sessionLead)
    } else {
      tonLeadService.createLead().then((res) => {
        sessionStorage.setItem(sessionStorageKey, res.id)
        setLead(res.id)
      })
    }
  }, [])

  async function updateLead(leadFields: Lead) {
    setLoading(true)

    try {
      await tonLeadService.updateLead(lead, leadFields)
    } catch (error) {
      throw error
    } finally {
      setLoading(false)
    }
  }

  return { id: lead, loading, updateLead }
}
